import { authService } from '../_services/auth.service'

const loadState = {
  LOADED: 0, 
  LOAD: 1
}

export default {
  namespaced: true, 

  state: {
    responseRestorePassword: null,
    responseRegister: null,
    loadStateRestorePassword: null,
    loadStateRegisterUser: null,
  },

  mutations: {

    setResponseRestorePassword(state, payload) {
      state.responseRestorePassword = payload
    },

    setLoadStateRestorePassword(state, payload) {
      state.loadStateRestorePassword = payload
    },

    setResponseRegisterUser(state, payload) {
      state.responseRegister = payload
    },

    setLoadStateRegisterUser(state, payload) {
      state.loadStateRegisterUser = payload
    },
    
  },
  
  actions: {

    loadRestorePassword({commit}, form) {
      commit('setLoadStateRestorePassword', loadState.LOADED)

      return authService.restorePassword(form).then(data => {
        commit('setResponseRestorePassword', data.data)
        commit('setLoadStateRestorePassword', loadState.LOAD)
      })

    },

    loadRegisterUser({commit}, form) {
      commit('setLoadStateRegisterUser', loadState.LOADED)

      return authService.registerUser(form).then(data => {
        commit('setResponseRegisterUser', data.data)
        commit('setLoadStateRegisterUser', loadState.LOAD)
      })

    },

    loadLogOut() {
      return authService.logOut()
    }

  }
  
}